export const SOURCE_PAGE_TYPE = 'topic';
export const PRESET_ALL = 'all';
export const PRESET_FREE = 'free';

export const TOPIC_PRESET_VALUES = {
    ALL: 'all',
    FREE: 'free',
    BEGINNER: 'beginner',
    EXPERT: 'expert',
} as const;

export const BUNDLE_DISCOUNT_CODE = 'BUNDLE_COUPON';

export const SPECIAL_VOUCHER_BUNDLE_DISCOUNT_PROPS = {
    isVoucherBundleDiscountEnabled: true,
    voucherBundleDiscountCode: BUNDLE_DISCOUNT_CODE,
};

export const CERTIFICATION_BUNDLE_SET = {
    INITIAL: 'INITIAL',
    FIRST_EXPANSION: 'FIRST_EXPANSION',
} as const;

/**
 * Minimum number of enrollments required to surface the learner count on the certification topic
 * hero. The threshold is applied on the frontend against the raw `numEnrollments` field.
 */
export const CERT_HERO_ENROLLMENT_THRESHOLD = 10_000;

export const SPECIAL_PRICING_TOPIC_IDS_BY_LOCALE: Record<string, number[]> = {
    de_DE: [7380, 6730, 158002, 6740, 4624, 583042, 8592, 4790, 6992, 7336],
    en_US: [
        643646, 583042, 6292, 7380, 8322, 4452, 4624, 6730, 6238, 721407, 6368, 7862, 5336, 5868,
        7166, 655953, 7336, 6282, 117052, 6866, 2146122, 9884, 5904, 6148, 618008, 158002, 5386,
        28016, 7220, 2004077, 6740, 6472, 7460, 8210, 155418, 6020, 158142, 4394, 158078, 8124,
        7216, 6298, 4908, 4280, 4398, 4404, 109866, 157089, 4904, 5880, 531256, 727283, 10684,
        536788, 4916, 6542, 6594, 7140, 6336, 155512, 51898, 5688, 615264, 5404, 6752, 4882, 4886,
        7788, 155420, 6906, 47952, 52458, 155842, 7830, 58206, 6316, 7632, 5340, 5892, 6630, 6284,
        5804, 7812, 6636, 5306, 157488, 7328, 9070, 7368, 5580, 5276, 8592, 6856, 12870, 155292,
        7818, 7190, 5042, 671603, 8166, 7900, 27248, 769769, 8662, 5800, 5798, 6042, 2349757, 5806,
        6744, 20736, 4284, 36020, 4674, 8472, 5430, 10776, 6450, 8154, 5972, 9252, 55400, 5346,
        34048, 156570, 149699, 10158, 7392, 158282, 7444, 5328, 156426, 157968, 5956, 8208, 5834,
        157954, 8088, 6198, 156157, 4620, 11098, 8232, 157578, 6706, 5156, 30506, 157140, 57548,
        7094, 5470, 592990, 7064, 28396, 4790, 5502, 18740, 7702, 155880, 7506, 6762, 5002, 7420,
        24852, 6266, 157972, 4898, 6742, 23948, 5954, 11088, 6498, 633546, 7450, 6252, 4692, 27950,
        130402, 6314, 4684, 6736, 9838, 82668, 7204, 4328, 4396, 22062, 8086, 91498, 8302, 105314,
        4484, 157686, 4894, 4818,
    ],
    es_ES: [
        7380, 6368, 6336, 5328, 4624, 8322, 5688, 5316, 158002, 6282, 4452, 721407, 6594, 158078,
        5626, 6730, 7862, 4790, 24774, 6978, 6740,
    ],
    fr_FR: [6740, 7380, 6730, 158002, 721407],
    it_IT: [55024, 7380, 6730],
    ja_JP: [
        7224, 24774, 7380, 5044, 118634, 46868, 4624, 6336, 4452, 6730, 157986, 11944, 4374, 157988,
        46554, 7450, 647968, 158142, 6740, 158078, 583042, 6732, 7892, 43860, 7336, 5156, 155382,
        6368, 158002, 156090, 8320, 8154, 24246,
    ],
    ko_KR: [109866],
    pl_PL: [7380],
    pt_BR: [
        7380, 7862, 4624, 6498, 6368, 7336, 6730, 6148, 6740, 158078, 8322, 721407, 7450, 6736,
        583042, 8124, 4904, 5336, 6336, 158142, 5884, 6540, 6020, 8592, 46868, 158002, 6042, 5156,
        4328, 5574, 6748, 6928, 7866, 4674, 6958, 5430, 5494, 7812, 4684, 6646, 9070, 6900, 28016,
        8154, 8210, 9652, 7098, 5470, 11272, 11944, 5580, 4790,
    ],
    tr_TR: [
        5336, 5626, 7380, 6730, 5942, 158002, 4904, 8322, 7818, 4674, 5430, 4328, 5688, 8004, 7862,
        8458,
    ],
};

export const GWG_TOPIC_IDS = [
    '676309',
    '583042',
    '157900',
    '157488',
    '4624',
    '2219646',
    '156088',
    '158002',
    '636452',
    '5316',
    '158100',
    '5328',
    '5336',
    '723291',
    '158078',
    '2004077',
    '592978',
    '6368',
    '2146122',
    '643646',
    '6498',
    '533350',
    '6594',
    '6736',
    '536788',
    '158096',
    '157089',
    '2003601',
    '611198',
    '7336',
    '158142',
    '7380',
    '30506',
    '7450',
    '618008',
    '7862',
    '158098',
    '8028',
];

export const CERTIFICATION_TOPIC_IDS: string[] = [
    '9838',
    '47970',
    '37110',
    '82672',
    '82668',
    '82666',
    '14156',
    '80166',
    '31198',
    '80498',
    '5044',
    '5174',
    '8436',
    '5170',
    '22284',
    '5166',
    '46126',
    '98238',
    '107392',
    '10776',
    '23674',
    '5048',
    '5050',
    '48206',
    '55442',
    '5176',
    '84272',
    '5178',
    '37854',
    '53842',
    '36592',
    '58206',
    '129301',
    '127946',
    '61964',
    '56414',
    '47848',
    '46868',
    '52886',
    '43860',
    '52836',
    '45884',
    '24774',
    '134070',
    '134074',
    '39310',
    '128934',
    '75242',
    '113114',
    '4940',
    '22592',
    '51812',
    '47922',
    '10628',
    '8622',
    '137530',
    '137528',
    '118634',
    '142360',
    '142358',
    '23840',
    '46738',
    '143004',
    '143012',
    '143026',
    '62748',
    '143044',
    '143048',
    '143212',
    '5168',
    '117052',
    '117740',
    '143426',
    '143428',
    '143430',
    '79232',
    '95782',
    '12050',
    '12802',
    '143592',
    '143594',
    '143596',
    '135754',
    '22062',
    '118956',
    '79610',
    '12808',
    '17666',
    '145034',
    '145044',
    '145282',
    '140844',
    '107208',
    '146038',
    '146052',
    '146100',
    '146102',
    '146050',
    '134540',
    '61052',
    '58836',
    '146694',
    '146724',
    '146764',
    '111452',
    '130036',
    '117756',
    '148158',
    '148160',
    '137300',
    '147826',
    '140040',
    '31450',
    '56868',
    '44258',
    '86486',
    '36886',
    '135000',
    '141902',
    '127194',
    '149699',
    '119446',
    '122900',
    '112576',
    '113947',
    '153002',
    '153746',
    '154486',
    '154526',
    '154532',
    '134828',
    '127048',
    '146330',
    '155252',
    '65048',
    '155254',
    '109878',
    '155260',
    '155262',
    '155264',
    '55400',
    '13106',
    '73590',
    '17260',
    '21572',
    '7750',
    '25646',
    '155266',
    '102426',
    '103170',
    '155270',
    '155278',
    '155288',
    '63840',
    '146042',
    '155304',
    '155308',
    '155342',
    '155346',
    '155348',
    '155350',
    '155352',
    '155354',
    '155356',
    '155360',
    '155368',
    '155370',
    '155372',
    '155374',
    '155376',
    '30922',
    '91464',
    '155384',
    '130402',
    '155404',
    '155414',
    '155420',
    '155422',
    '155424',
    '155430',
    '155432',
    '155446',
    '155450',
    '155452',
    '155454',
    '155458',
    '155464',
    '155468',
    '155466',
    '155470',
    '155472',
    '155474',
    '155476',
    '155478',
    '155480',
    '155486',
    '155488',
    '155490',
    '155494',
    '155498',
    '155500',
    '155512',
    '155516',
    '155518',
    '155520',
    '155522',
    '155524',
    '155528',
    '155532',
    '155534',
    '155536',
    '155548',
    '155550',
    '155552',
    '155554',
    '155556',
    '155558',
    '155564',
    '155566',
    '155568',
    '155582',
    '155586',
    '155594',
    '155598',
    '155605',
    '155618',
    '155624',
    '155626',
    '155630',
    '155634',
    '155636',
    '155358',
    '155640',
    '155652',
    '155656',
    '155666',
    '155668',
    '155680',
    '155686',
    '155688',
    '155696',
    '155698',
    '155712',
    '155714',
    '155722',
    '155736',
    '155746',
    '155756',
    '155754',
    '155762',
    '155764',
    '155782',
    '82986',
    '155814',
    '155826',
    '155832',
    '155834',
    '155860',
    '155880',
    '155882',
    '155894',
    '155898',
    '155900',
    '155946',
    '155948',
    '155952',
    '155972',
    '155986',
    '155988',
    '156000',
    '156004',
    '156020',
    '156022',
    '156050',
    '156066',
    '156072',
    '156086',
    '156090',
    '156024',
    '156102',
    '156159',
    '156167',
    '156174',
    '156192',
    '156194',
    '156276',
    '156278',
    '156279',
    '156281',
    '156283',
    '156285',
    '156290',
    '156338',
    '156340',
    '156344',
    '156366',
    '156368',
    '39014',
    '156370',
    '156416',
    '156424',
    '156432',
    '156434',
    '156444',
    '156450',
    '156454',
    '156464',
    '156468',
    '156472',
    '156490',
    '7224',
    '156498',
    '156504',
    '156506',
    '156508',
    '156512',
    '156514',
    '156518',
    '156520',
    '156532',
    '156544',
    '156550',
    '156554',
    '156564',
    '156570',
    '156576',
    '156578',
    '156584',
    '156588',
    '156606',
    '156610',
    '156616',
    '156622',
    '156626',
    '156646',
    '156648',
    '156650',
    '156660',
    '156684',
    '156700',
    '156722',
    '156768',
    '156802',
    '156804',
    '156886',
    '156908',
    '156912',
    '156918',
    '156932',
    '157028',
    '157030',
    '157126',
    '157142',
    '157144',
    '157178',
    '157190',
    '157224',
    '157250',
    '157262',
    '157282',
    '157316',
    '157322',
    '157332',
    '157340',
    '157342',
    '157358',
    '157360',
    '157374',
    '157388',
    '157390',
    '157406',
    '157418',
    '157460',
    '157486',
    '157490',
    '157516',
    '157520',
    '157524',
    '155742',
    '157534',
    '157562',
    '157324',
    '157660',
    '157668',
    '157678',
    '157696',
    '157702',
    '151042',
    '4992',
    '157794',
    '139382',
    '157866',
    '157896',
    '128936',
    '157952',
    '157954',
    '157962',
    '157968',
    '157988',
    '157986',
    '157994',
    '158012',
    '158040',
    '158108',
    '157348',
    '157674',
    '156552',
    '5094',
    '157758',
    '157121',
    '48844',
    '56782',
    '72934',
    '129910',
    '155968',
    '155960',
    '80312',
    '158116',
    '158158',
    '158160',
    '157870',
    '155382',
    '155386',
    '158234',
    '158236',
    '158270',
    '158272',
    '157904',
    '74920',
    '51898',
    '158282',
    '158284',
    '158312',
    '158318',
    '158338',
    '531256',
    '531258',
    '531238',
    '2013511',
    '2139114',
    '544210',
    '535452',
    '2077454',
    '2146618',
    '2110057',
    '2050360',
    '2045262',
    '2149021',
    '2145163',
    '2062102',
    '2055753',
    '2086432',
    '2059398',
    '2074462',
    '2101148',
    '543390',
    '2032312',
    '548706',
    '2120623',
    '2182609',
    '2182864',
    '2182871',
    '565138',
    '2182874',
    '2182880',
    '2182882',
    '2182883',
    '2182885',
    '2182888',
    '2182894',
    '2183050',
    '2183053',
    '2183055',
    '2183061',
    '2183064',
    '2183065',
    '2183067',
    '2183068',
    '2183071',
    '2183072',
    '2183075',
    '2030911',
    '2152279',
    '2148666',
    '547836',
    '567014',
    '2184517',
    '2184203',
    '553238',
    '560260',
    '569460',
    '2183129',
    '573216',
    '2182389',
    '2190457',
    '158132',
    '582290',
    '2206994',
    '539916',
    '592990',
    '574232',
    '30748',
    '2219646',
    '4324',
    '552050',
    '607624',
    '562392',
    '537304',
    '605208',
    '611478',
    '609388',
    '606894',
    '602768',
    '586080',
    '567456',
    '2273194',
    '2273216',
    '2273221',
    '2278179',
    '647968',
    '644994',
    '655953',
    '677601',
    '672629',
    '2349751',
    '2349752',
    '2349754',
    '2349755',
    '2349757',
    '581004',
    '631980',
    '672105',
    '666981',
    '2378383',
    '713461',
    '2391284',
    '727283',
    '694221',
    '661611',
    '2408146',
    '2408160',
    '2409853',
    '2410990',
    '2411666',
    '2422143',
    '2433540',
    '2439567',
    '2439590',
    '2422148',
    '769769',
    '701857',
    '2478011',
    '2478013',
    '612028',
    '2503054',
    '748691',
    '775259',
    '762185',
    '829371',
    '662689',
    '848539',
    '697059',
    '649000',
    '2553584',
    '2553587',
    '2562969',
    '2566283',
    '2566284',
    '855513',
    '785675',
    '2574952',
    '2581271',
    '2581278',
    '740869',
    '2590782',
    '2616418',
    '2648841',
    '2648929',
    '2648941',
    '2655596',
    '2666045',
    '2666049',
];
